export { MessageThreadCollapsible } from "./message-thread-collapsible";
